import * as i0 from "@angular/core";
var UtilDate = /** @class */ (function () {
    function UtilDate() {
    }
    UtilDate.prototype.formatStringToDate = function (dateString) {
        return new Date(Number.parseInt(dateString.slice(4, 8)), Number.parseInt(dateString.slice(2, 4)) - 1, Number.parseInt(dateString.slice(0, 2)));
    };
    UtilDate.prototype.formatDate = function (date) {
        var dayString = date.getDate() < 10 ? '0' : '';
        var monthString = date.getMonth() < 9 ? '0' : '';
        var dateString = dayString + date.getDate().toString() + monthString + (date.getMonth() + 1).toString() + date.getFullYear().toString();
        return dateString;
    };
    UtilDate.ngInjectableDef = i0.defineInjectable({ factory: function UtilDate_Factory() { return new UtilDate(); }, token: UtilDate, providedIn: "root" });
    return UtilDate;
}());
export { UtilDate };
